import { ConfirmationWrapperStyled } from "./styles";

import { ReservationConfirmationCard } from "../ReservationConfirmationCard";
import { Spacer } from "../common/Spacer";
import { Typography } from "antd";

import { useTranslation } from "react-i18next";
import React from "react";
const { Title } = Typography;

export const ConfirmationWrapper = ({
	fieldsExist,
	isLoggedIn,
	officeName,
	lineName,
	selectedDate,
	onClick,
	attentionType,
	desktop,
	officeDirection,
}) => {
	const { t } = useTranslation("booking");

	return (
		<ConfirmationWrapperStyled
			fieldsExist={fieldsExist}
			isLoggedIn={isLoggedIn}
			desktop={desktop}
		>
			{!desktop && (
				<>
					<div className="current-step-label">{t("lastStep")}</div>
					<Title level={5}>{t("lastStepMessage")}</Title>
				</>
			)}
			<ReservationConfirmationCard
				officeName={officeName}
				lineName={lineName}
				officeDirection={officeDirection}
				selectedDate={selectedDate}
				onClick={onClick}
				attentionType={attentionType}
				desktop={desktop}
			/>

			<Spacer rows={1} />
		</ConfirmationWrapperStyled>
	);
};
